<template>
  <div>
    <el-table :data="list" stripe style="width: 100%" size="mini">
      <slot />
      <el-table-column
        v-if="viewable || editable || deletable"
        label="操作"
        width="180"
        header-align="center"
        align="center"
      >
        <template scope="scope">
          <div class="operation">
            <el-button
              size="mini"
              icon="el-icon-view"
              v-if="viewable"
              @click="handleView(scope.$index, scope.row)"
            ></el-button>
            <el-button
              size="mini"
              icon="el-icon-edit"
              v-if="editable"
              type="success"
              @click="handleEdit(scope.$index, scope.row)"
            ></el-button>
            <el-button
              size="mini"
              icon="el-icon-delete"
              v-if="deletable"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :default-page="this.defaultPage"
      :default-page-size="defaultPageSize"
      :total="total"
    >
    </pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      defaultPage: 1,
      defaultPageSize: 10,
      total: 0,
    };
  },
  created: function () {
    this.fetchData();
  },
  watch: {
    $route: "fetchData",
  },
  methods: {
    fetchData() {
      let params = Object.assign({}, this.params, this.$route.query);
      params.page = this.page;
      params.size = this.pageSize;
      let that = this;
      this.dataApi.listpage(params).then(function (response) {
        if (!response.data.errorCode) {
          that.list = response.data.data.records;
          that.total = response.data.data.total;
        }
      });
    },
    handleView(index, row) {
      this.$router.push({
        path: "view/" + row[this.keyField],
        params: { id: row[this.keyField] },
      });
    },
    handleEdit(index, row) {
      this.$router.push({
        path: this.editPath,
        query: { id: row[this.keyField] },
      });
    },
    handleDelete(index, row) {
      var that = this;
      this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.dataApi
            .remove({ id: row[this.keyField] })
            .then(function (response) {
              if (!response.data.errorCode) {
                that.fetchData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  computed: {
    page: function () {
      if (this.$route.query.page) {
        return parseInt(this.$route.query.page);
      } else {
        return this.defaultPage;
      }
    },
    pageSize: function () {
      if (this.$route.query.pageSize) {
        return parseInt(this.$route.query.pageSize);
      } else {
        return this.defaultPageSize;
      }
    },
  },
  props: {
    dataApi: { type: Object, required: true },
    viewable: { type: Boolean, default: false },
    editable: { type: Boolean, default: true },
    editPath: { type: String, default: "edit" },
    deletable: { type: Boolean, default: true },
    keyField: { type: String, default: "id" },
    params: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
};
</script>
<style scoped>
.operation >>> button {
  margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// PageTable.vue?3fce93ca